import { AppView } from '../../graphQL';

const terms: Record<AppView, string | null> = {
  oz: null,
  mcp: `assets/terms/mcp/${encodeURIComponent('Terms of Use.pdf')}`,
  referral: `assets/terms/referral/${encodeURIComponent('Terms of Use.pdf')}`,
};

export const getTerms = (view: AppView) => terms[view];
